import {useEffect, useState} from "react";
import {createVoucher, fetchVouchers, removeVoucher, updateVoucher} from "../api/api";
import BottomSheet from "../components/BottomSheet";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {useApp} from "../Contex";

export default function Vouchers(){
    const {refresh, permissions: {write}} = useApp()
    const [voucherList, setVoucherList] = useState([]);
    const [editVoucher, setEditVoucher] = useState(null);
    const [addVoucher, setAddVoucher] = useState(null);

    const fetchData = () => {
        fetchVouchers().then((res) => {
            if(res.ok){
                setVoucherList(res.voucherList)
            }
        })
    }
    useEffect(() => {
        fetchData()
    },[refresh])

    function onUpdate (update){
        updateVoucher(update).then((res)=>{
            if(res.ok){
                setEditVoucher(null)
                fetchData()
            }
        })
    }

    function onAdd (voucher){
        createVoucher(voucher).then((res)=>{
            if(res.ok){
                setAddVoucher(false)
                fetchData()
            }
        })
    }

    function VoucherItem({ voucher }) {
        const { code, value, vSid, assignedTo } = voucher;
        const isGlobal = (vSid === null);
        const isClosed = (assignedTo === null);

        return (
            <div className="card mb-3 px-3 py-2 bg-light" onClick={()=>{if(write)setEditVoucher(voucher)}}>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <p className="fs-5 fw-bold mb-0">{code}</p>
                        <span className="text-muted">{value}% rabatt</span>
                    </div>
                    <div className="text-end">
                    <span className={`badge me-1 ${isGlobal ? "bg-primary" : "bg-secondary"}`}>
                        {isGlobal ? "Global" : "Lokal"}
                    </span>
                        <span className={`badge ${isClosed ? "bg-success" : "bg-warning"}`}>
                        {isClosed ? "Publik":"Privat"}
                    </span>
                    </div>
                </div>
            </div>
        );
    }


    function VoucherModal({ editVoucher, setEditVoucher, onSave, showDelete=true}) {
        const [voucher, setVoucher] = useState(editVoucher);
        const [isPublic, setIsPublic] = useState(!Array.isArray(editVoucher.assignedTo));
        const [hasDeadline, setHasDeadline] = useState(!!editVoucher.expiresAt)
        const [itemChanged, setItemChanged] = useState(false);

        useEffect(() => {
            setVoucher(editVoucher);
            setIsPublic(!Array.isArray(editVoucher.assignedTo));
            setItemChanged(false);
            setHasDeadline(!!editVoucher.expiresAt)
        }, [editVoucher]);

        if (!voucher) return null;

        function handleFieldChange(field, value) {
            setVoucher(prev => ({ ...prev, [field]: value }));
            setItemChanged(true);
        }
        const handleSave = () => {
            const update = voucher;
            if(isPublic){
                update.assignedTo = null
            }

            onSave(update)
        }

        function VoucherPhoneSelect({ assignedTo, setAssignedTo }) {
            const value = (assignedTo || []).map(phone => ({
                label: phone,
                value: phone
            }));

            const handleChange = (selectedOptions) => {
                const phones = selectedOptions.map(opt => opt.value);
                setAssignedTo(phones);
                setItemChanged(true);
            };

            const customStyles = {
                valueContainer: (base) => ({
                    ...base,
                    maxHeight: '4.5em',
                    overflowY: 'auto',
                    flexWrap: 'wrap',
                }),
            };

            return (
                <CreatableSelect
                    isMulti
                    placeholder="Lägg till..."
                    value={value}
                    onChange={handleChange}
                    onCreateOption={(inputValue) => {
                        const newOption = { label: inputValue, value: inputValue };
                        handleChange([...value, newOption]);
                    }}
                    options={[]}
                    components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                    noOptionsMessage={() => null}
                    styles={customStyles}
                />
            );
        }

        return (
            <div>
                <h5 className="mb-3">{showDelete? "Redigera rabattkod" : "Skapa ny rabattkod"}</h5>
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Kod</label>
                        <input
                            value={voucher.code ?? ""}
                            onChange={(e) => handleFieldChange("code", e.target.value)}
                            className="form-control"
                        />

                        <label className="form-label mt-3">Värde (%)</label>
                        <input
                            value={voucher.value ?? 0}
                            type="number"
                            onChange={(e) => handleFieldChange("value", Number(e.target.value))}
                            className="form-control"
                        />

                        <label className="form-label mt-3">Tillgängligt antal</label>
                        <input
                            value={voucher.limitTotal ?? 0}
                            type="number"
                            onChange={(e) => handleFieldChange("limitTotal", Number(e.target.value))}
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Tillgänglighet</label>
                        <div className="d-flex border border-secondary rounded-pill overflow-hidden mb-2">
                            <div
                                className={`w-50 text-center py-1 px-2 ${isPublic ? "bg-secondary text-white" : "bg-light"}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    setIsPublic(true);
                                    //handleFieldChange("assignedTo", null);
                                    setItemChanged(true);
                                }}
                            >
                                Publik
                            </div>
                            <div
                                className={`w-50 text-center py-1 px-2 ${!isPublic ? "bg-secondary text-white" : "bg-light"}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    setIsPublic(false);
                                    if(voucher?.assignedTo === null || voucher?.assignedTo === undefined) {
                                        setVoucher((prev)=>({ ...prev, assignedTo: [] }));
                                    }
                                    setItemChanged(true);
                                }}
                            >
                                Privat
                            </div>
                        </div>

                        {!isPublic && Array.isArray(voucher.assignedTo) && (
                            <div className="mt-2">
                                <label className="form-label">Tillåtna användare (tel.)</label>
                                <VoucherPhoneSelect
                                    assignedTo={voucher.assignedTo}
                                    setAssignedTo={(value) =>
                                        handleFieldChange("assignedTo", value)
                                    }
                                />
                            </div>
                        )}
                        <div>
                            <label>Tidsperiod</label>
                            <div className="d-flex border border-secondary rounded-pill overflow-hidden my-2">
                                <div
                                    className={`w-50 text-center py-1 px-2 ${!hasDeadline ? "bg-secondary text-white" : "bg-light"}`}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        setHasDeadline(false);
                                        //handleFieldChange("assignedTo", null);
                                        setItemChanged(true);
                                    }}
                                >
                                    Tillsvidare
                                </div>
                                <div
                                    className={`w-50 text-center py-1 px-2 ${hasDeadline ? "bg-secondary text-white" : "bg-light"}`}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        setHasDeadline(true);
                                        if (voucher?.expiresAt === null || voucher?.expiresAt === undefined) {
                                            setVoucher((prev) => ({...prev, expiresAt: new Date().toISOString()}));
                                        }
                                        setItemChanged(true);
                                    }}
                                >
                                    Tidsbestämd
                                </div>
                            </div>
                            {hasDeadline && voucher.expiresAt &&
                                <div>
                                    <label>Slutdatum</label>
                                    <input type={"date"}
                                           onChange={(e) => handleFieldChange("expiresAt", new Date(e.target.value).toISOString())}
                                           value={voucher.expiresAt.split('T')[0]}
                                           className="form-control"
                                    />
                                </div>
                            }

                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-4">
                    {showDelete &&
                        <button className="btn btn-outline-danger" onClick={() => {
                            removeVoucher(voucher["_id"]).then((res) => {
                                if (res.ok) {
                                    setEditVoucher(null)
                                    fetchData()
                                }
                            })
                        }}>
                            Ta bort
                        </button>
                    }
                    {(!showDelete || itemChanged) && write && (
                        <button className="btn btn-success" style={{marginLeft: "auto"}} onClick={handleSave}>
                            Spara ändringar
                        </button>
                    )}
                </div>
            </div>
        );
    }


    return (<>
            <div className="d-flex align-items-center justify-content-between">
                <h1>Rabattkoder</h1>
                {write &&
                <button className="btn btn-secondary" onClick={() => {
                    setAddVoucher({})
                }}><i className="bi bi-plus-square-dotted"></i> Skapa ny
                </button>
                }
            </div>
            {voucherList.map((voucher) => {
                    return <VoucherItem voucher={voucher} key={voucher["_id"]}/>
                }
            )}
            <BottomSheet show={editVoucher} setShow={setEditVoucher} children={<VoucherModal editVoucher={editVoucher} setEditVoucher={setEditVoucher} onSave={onUpdate}/>}/>
            <BottomSheet show={addVoucher} setShow={setAddVoucher} children={<VoucherModal editVoucher={addVoucher} setEditVoucher={setAddVoucher} onSave={onAdd} showDelete={false}/> }/>
        </>
    )
}
